import React, { useEffect, useState } from 'react'

import { Modal } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, func, string, node,
} from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function CheckoutShareModal({
  isOpen: initialIsOpen = true,
  onClose = NOOP,
  canClose = true,
  customClass = '',
  header = '',
  headerIcon = null,
  children = null,
  afterOpenModal = NOOP,
}) {
  const [isOpen, setIsOpen] = useState(initialIsOpen)

  useEffect(() => {
    setIsOpen(initialIsOpen)
  }, [initialIsOpen])

  function closeModal() {
    setIsOpen(false)
    onClose()
  }

  if (!isOpen) {
    return null
  }

  return (
    <Modal
      size="small"
      width="small"
      isOpen={isOpen}
      canClose={canClose}
      onClose={closeModal}
      customClass={customClass}
      onAfterOpen={afterOpenModal}
      header={header}
      headerIcon={headerIcon}
    >
      {children}
    </Modal>
  )
}

CheckoutShareModal.propTypes = {
  isOpen: bool,
  onClose: func,
  canClose: bool,
  customClass: string,
  header: string,
  headerIcon: node,
  children: node,
  afterOpenModal: func,
}

export default CheckoutShareModal
